/* eslint-disable max-len */
const required = 'This field is required'

export const ACCOUNT_CREATE_FORM_CONFIG = {
  firstName: {
    label: 'First Name',
    errorMessages: { required }
  },
  lastName: {
    label: 'Last Name',
    errorMessages: { required }
  },
  dateOfBirth: {
    label: 'Date of Birth',
    errorMessages: {
      required,
      dateInvalid: 'Date is invalid',
      dateOutOfRange: 'Date is unavailable',
      dob18: 'You are not eligible to create a SportsEngine account. Please ask your parent or guardian to create an account.'
    },
    yearRange: { future: 0, past: 100 }
  },
  email: {
    label: 'Email',
    errorMessages: {
      required,
      email: 'Please enter a valid email'
    }
  },
  phone: {
    label: 'Phone',
    errorMessages: {
      required,
      phone10To12: 'Please enter a valid phone number'
    }
  }
}
